import {
  Airline,
  Country,
  GetFlightDateOptionsResponse,
  GetOtherFlightsResponse,
  Hotel,
  SearchTourPackagesRequest
} from '@appTypes/api.types';
import { DistrictsTreeItem } from '@appTypes/redefined-types';
import { RequestStateModel, StateFormModel } from '@core/store/store.models';
import { SearchTourPackagesFormExtraParams, TourPackageResultsResponse } from '../tours.types';

export class ToursFlightAvailabilityModel {
  data = new RequestStateModel<GetFlightDateOptionsResponse>();
  identifier!: string;
}
export class ToursSearchFormDataModel {
  availableAirlines = new RequestStateModel<Airline[]>();
  arrivalDistricts = new RequestStateModel<DistrictsTreeItem[]>();
  hotels = new RequestStateModel<Hotel[]>();
  destinationCountries = new RequestStateModel<Country[]>();
  /** the country the search form opens with, as the API names it (Destination Module default); null = none */
  destinationDefaultCountry: string | null = null;
  /** DEST-017: the departure city the Destination Module's default names for this agent, when it has one; null = none */
  destinationDefaultDepartureCityUID: string | null = null;
  flightAvailabilities: ToursFlightAvailabilityModel[] = [];
}

export class ToursChildResultsModel {
  parentHotelCode!: string;
  results = new RequestStateModel<TourPackageResultsResponse>();
}
export class ToursStateModel {
  searchForm = new StateFormModel<SearchTourPackagesRequest & SearchTourPackagesFormExtraParams>();
  searchFormData = new ToursSearchFormDataModel();
  /*  */
  searchResults = new RequestStateModel<TourPackageResultsResponse>();
  childResults: ToursChildResultsModel[] = [];
  /*  */
  selectedTourOtherPackages = new RequestStateModel<GetOtherFlightsResponse>();
}
